import React, { useState, useEffect } from 'react';
import axios from 'axios';
import HeaderBar from '../components/HeaderBar';
import './AdminDeskAllocation.css';

function AdminDeskAllocation({ user, onLogout }) {
    const [allocationData, setAllocationData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [selectedDay, setSelectedDay] = useState(0);

    useEffect(() => {
        fetchAllocationData();
    }, []);

    const fetchAllocationData = async () => {
        try {
            setLoading(true);
            const response = await axios.get('/api/admin/desk-allocation-multi-day?days=5');
            setAllocationData(response.data || []);
        } catch (err) {
            console.error('Failed to fetch allocation data:', err);
            setError(err.response?.data?.error || 'Failed to load allocation data');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="admin-desk-allocation">
                <HeaderBar user={user} onLogout={onLogout} />
                <div className="allocation-container">
                    <p>Loading allocation data...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="admin-desk-allocation">
                <HeaderBar user={user} onLogout={onLogout} />
                <div className="allocation-container">
                    <div className="error">{error}</div>
                </div>
            </div>
        );
    }

    const currentDayData = allocationData[selectedDay] || {};

    return (
        <div className="admin-desk-allocation">
            <HeaderBar user={user} onLogout={onLogout} />

            <div className="allocation-container">
                <div className="allocation-header">
                    <h1>📊 Desk Allocation - Next 5 Days</h1>
                    <p className="allocation-subtitle">View desk allocation breakdown by unit for upcoming workdays</p>
                </div>

                {/* Day selector tabs */}
                <div className="day-tabs">
                    {allocationData.map((day, index) => (
                        <button
                            key={day.date}
                            className={`day-tab ${selectedDay === index ? 'active' : ''}`}
                            onClick={() => setSelectedDay(index)}
                        >
                            <div className="tab-day">{day.dayName}</div>
                            <div className="tab-date">
                                {new Date(day.date).toLocaleDateString('en-US', {
                                    month: 'short',
                                    day: 'numeric'
                                })}
                            </div>
                            <div className="tab-occupancy">
                                {day.bookedDesks}/{day.totalDesks}
                            </div>
                        </button>
                    ))}
                </div>

                {/* Summary cards */}
                <div className="allocation-summary">
                    <div className="summary-card">
                        <div className="summary-icon">📅</div>
                        <div className="summary-content">
                            <div className="summary-label">Total Booked</div>
                            <div className="summary-value">{currentDayData.bookedDesks || 0}</div>
                        </div>
                    </div>
                    <div className="summary-card">
                        <div className="summary-icon">✅</div>
                        <div className="summary-content">
                            <div className="summary-label">Total Available</div>
                            <div className="summary-value">{currentDayData.availableDesks || 0}</div>
                        </div>
                    </div>
                    <div className="summary-card">
                        <div className="summary-icon">🏢</div>
                        <div className="summary-content">
                            <div className="summary-label">Total Desks</div>
                            <div className="summary-value">{currentDayData.totalDesks || 0}</div>
                        </div>
                    </div>
                </div>

                {/* Unit breakdown */}
                <div className="unit-breakdown">
                    <h2>Breakdown by Unit</h2>
                    <div className="units-list">
                        {currentDayData.unitBreakdown && currentDayData.unitBreakdown.length > 0 ? (
                            currentDayData.unitBreakdown.map((unitData) => (
                                <div key={unitData.unit} className="unit-row">
                                    <div className="unit-name">{unitData.unit}</div>
                                    <div className="unit-stats">
                                        <div className="stat-badge booked-badge">
                                            <span className="badge-value">{unitData.booked}</span>
                                            <span className="badge-label">booked</span>
                                        </div>
                                        <div className="stat-badge available-badge">
                                            <span className="badge-value">{unitData.available}</span>
                                            <span className="badge-label">available</span>
                                        </div>
                                        <div className="unit-progress">
                                            <div className="progress-bar">
                                                <div
                                                    className="progress-fill"
                                                    style={{ width: `${(unitData.booked / unitData.total) * 100}%` }}
                                                ></div>
                                            </div>
                                            <span className="progress-text">{unitData.total} total</span>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="empty-message">No units available</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminDeskAllocation;
